// ... (import statements and previous code)

const ProductsOrderTable = ({item,setter}) => {
  
    return (

        <tr>
          <td className="px-5 py-3 border-b-2 border-gray-200 bg-white text-left text-xs font-semibold text-black uppercase tracking-wider">
            <div className="flex items-center">
              <div className="flex-shrink-0 w-10 h-10">
                <img
                  className="w-full h-full rounded-full"
                  src={item.orderItem.image}
                  alt=""
                />
              </div>
              <div className="ml-3">
                <p className="text-gray-900 whitespace-no-wrap">
                  {item.orderItem.name}
                </p>
              </div>
            </div>
          </td>
          <td className="px-5 py-3 border-b-2 border-gray-200 bg-white text-left text-xs font-semibold text-black uppercase tracking-wider">
            <p className="text-gray-900 whitespace-no-wrap">{item.Name}</p>
          </td>
          <td className="px-5 py-3 border-b-2 border-gray-200 bg-white text-left text-xs font-semibold text-black uppercase tracking-wider">
            <p className="text-gray-900 whitespace-no-wrap">{item.createdAt.substring(0,10)}</p>
          </td>
          <td className="px-5 py-3 border-b-2 border-gray-200 bg-white text-left text-xs font-semibold text-black uppercase tracking-wider">
            <p className="text-gray-900 whitespace-no-wrap">{item.Price}</p>
          </td>
          <td className="px-5 py-3 border-b-2 border-gray-200 bg-white text-left text-xs font-semibold text-black uppercase tracking-wider">
            <button className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 border-b-4 border-blue-700 hover:border-blue-500 rounded" onClick={()=>setter(item)}>Get Info</button>
          </td>
        </tr>
  
      // ... (rest of the code)
    );
  };
  
  export default ProductsOrderTable;
  